/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-strava-form',
  templateUrl: './strava-form.component.html',
  styleUrls: ['./strava-form.component.scss'],
})
export class StravaFormComponent implements OnInit {
  url;

  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  save(id) {
    this.modalController.dismiss({
      type: 'stravaId',
      data: id,
    });
  }
}
